/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermosDeUsoRouteImport } from './routes/termos-de-uso'
import { Route as PoliticaDePrivacidadeRouteImport } from './routes/politica-de-privacidade'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as EscolherEmailRouteImport } from './routes/escolher-email'
import { Route as ContaExcluidaRouteImport } from './routes/conta-excluida'
import { Route as BoasVindasRouteImport } from './routes/boas-vindas'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VagasIndexRouteImport } from './routes/vagas/index'
import { Route as ProgramasIndexRouteImport } from './routes/programas/index'
import { Route as PerfilIndexRouteImport } from './routes/perfil/index'
import { Route as OportunidadesIndexRouteImport } from './routes/oportunidades/index'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding/index'
import { Route as ModulosIndexRouteImport } from './routes/modulos/index'
import { Route as VagasMotivoReprovacaoEmailRouteImport } from './routes/vagas/motivo-reprovacao-email'
import { Route as VagasJobIdRouteImport } from './routes/vagas/$jobId'
import { Route as SubscriptionSuccessRouteImport } from './routes/subscription/success'
import { Route as ProgramasIdRouteImport } from './routes/programas/$id'
import { Route as PerfilTrocarSenhaRouteImport } from './routes/perfil/trocar-senha'
import { Route as PerfilDadosPessoaisRouteImport } from './routes/perfil/dados-pessoais'
import { Route as PerfilCurriculoRouteImport } from './routes/perfil/curriculo'
import { Route as PerfilContasVinculadasRouteImport } from './routes/perfil/contas-vinculadas'
import { Route as OnboardingVerificacaoRouteImport } from './routes/onboarding/verificacao'
import { Route as OnboardingTermosRouteImport } from './routes/onboarding/termos'
import { Route as OnboardingLocalidadeRouteImport } from './routes/onboarding/localidade'
import { Route as OnboardingFormacaoRouteImport } from './routes/onboarding/formacao'
import { Route as OnboardingCelularRouteImport } from './routes/onboarding/celular'
import { Route as ModulosConclusaoRouteImport } from './routes/modulos/conclusao'
import { Route as ModulosModuleIdRouteImport } from './routes/modulos/$moduleId'
import { Route as VagasMotivoReprovacaoIndexRouteImport } from './routes/vagas/motivo-reprovacao/index'
import { Route as PerfilFotoIndexRouteImport } from './routes/perfil/foto/index'
import { Route as PerfilExcluirContaIndexRouteImport } from './routes/perfil/excluir-conta/index'
import { Route as PerfilDadosPessoaisIndexRouteImport } from './routes/perfil/dados-pessoais/index'
import { Route as PerfilCurriculoIndexRouteImport } from './routes/perfil/curriculo/index'
import { Route as VagasJobIdProcessoRouteImport } from './routes/vagas/$jobId_.processo'
import { Route as VagasJobIdInscricaoRouteImport } from './routes/vagas/$jobId_.inscricao'
import { Route as PerfilFotoPreviewRouteImport } from './routes/perfil/foto/preview'
import { Route as PerfilEditarSelecionarFormacaoRouteImport } from './routes/perfil/editar/selecionar-formacao'
import { Route as PerfilEditarEmailRouteImport } from './routes/perfil/editar/email'
import { Route as PerfilEditarAdicionarFormacaoRouteImport } from './routes/perfil/editar/adicionar-formacao'
import { Route as PerfilEditarAdicionarCurriculoRouteImport } from './routes/perfil/editar/adicionar-curriculo'
import { Route as PerfilDadosPessoaisVerificacaoRouteImport } from './routes/perfil/dados-pessoais/verificacao'
import { Route as PerfilDadosPessoaisLocalidadeRouteImport } from './routes/perfil/dados-pessoais/localidade'
import { Route as PerfilDadosPessoaisDiversidadeRouteImport } from './routes/perfil/dados-pessoais/diversidade'
import { Route as PerfilDadosPessoaisCelularRouteImport } from './routes/perfil/dados-pessoais/celular'
import { Route as PerfilCurriculoSucessoRouteImport } from './routes/perfil/curriculo_.sucesso'
import { Route as PerfilCurriculoRevisarRouteImport } from './routes/perfil/curriculo/revisar'
import { Route as PerfilCurriculoPreviaRouteImport } from './routes/perfil/curriculo/previa'
import { Route as PerfilCurriculoEnviarRouteImport } from './routes/perfil/curriculo/enviar'
import { Route as PerfilCurriculoEditarRouteImport } from './routes/perfil/curriculo/editar'
import { Route as PerfilCurriculoDadosPessoaisRouteImport } from './routes/perfil/curriculo/dados-pessoais'
import { Route as ModulosModuleIdCurriculoRouteImport } from './routes/modulos/$moduleId_.curriculo'
import { Route as VagasJobIdInscricaoIndexRouteImport } from './routes/vagas/$jobId_.inscricao.index'
import { Route as PerfilEditarFormacoesIndexRouteImport } from './routes/perfil/editar/formacoes/index'
import { Route as PerfilCurriculoSectionIndexRouteImport } from './routes/perfil/curriculo/$section/index'
import { Route as ModulosModuleIdCurriculoIndexRouteImport } from './routes/modulos/$moduleId_.curriculo.index'
import { Route as VagasJobIdInscricaoRevisaoRouteImport } from './routes/vagas/$jobId_.inscricao.revisao'
import { Route as VagasJobIdInscricaoProgramaEmAndamentoRouteImport } from './routes/vagas/$jobId_.inscricao.programa-em-andamento'
import { Route as VagasJobIdInscricaoFormularioRouteImport } from './routes/vagas/$jobId_.inscricao.formulario'
import { Route as VagasJobIdInscricaoAreasDeAtuacaoRouteImport } from './routes/vagas/$jobId_.inscricao.areas-de-atuacao'
import { Route as VagasJobIdInscricaoAcessibilidadeRouteImport } from './routes/vagas/$jobId_.inscricao.acessibilidade'
import { Route as UsersUserIdSubscriptionOrderPriorityRouteImport } from './routes/users/$userId/subscription/order-priority'
import { Route as UsersUserIdSubscriptionSubscriptionIdRouteImport } from './routes/users/$userId/subscription/$subscriptionId'
import { Route as PerfilEditarFormacoesIdRouteImport } from './routes/perfil/editar/formacoes/$id'
import { Route as PerfilCurriculoSectionNovaRouteImport } from './routes/perfil/curriculo/$section/nova'
import { Route as ModulosModuleIdCurriculoRevisarRouteImport } from './routes/modulos/$moduleId_.curriculo.revisar'
import { Route as ModulosModuleIdCurriculoPreviaRouteImport } from './routes/modulos/$moduleId_.curriculo.previa'
import { Route as ModulosModuleIdCurriculoEnviarRouteImport } from './routes/modulos/$moduleId_.curriculo.enviar'
import { Route as ModulosModuleIdCurriculoEditarRouteImport } from './routes/modulos/$moduleId_.curriculo.editar'
import { Route as ModulosModuleIdCurriculoDadosPessoaisRouteImport } from './routes/modulos/$moduleId_.curriculo.dados-pessoais'
import { Route as ModulosModuleIdCurriculoSectionIndexRouteImport } from './routes/modulos/$moduleId_.curriculo.$section.index'
import { Route as PerfilCurriculoSectionItemIdEditarRouteImport } from './routes/perfil/curriculo/$section/$itemId/editar'
import { Route as ModulosModuleIdCurriculoSectionNovaRouteImport } from './routes/modulos/$moduleId_.curriculo.$section.nova'
import { Route as ModulosModuleIdCurriculoSectionItemIdEditarRouteImport } from './routes/modulos/$moduleId_.curriculo.$section.$itemId.editar'

const TermosDeUsoRoute = TermosDeUsoRouteImport.update({
  id: '/termos-de-uso',
  path: '/termos-de-uso',
  getParentRoute: () => rootRouteImport,
} as any)
const PoliticaDePrivacidadeRoute = PoliticaDePrivacidadeRouteImport.update({
  id: '/politica-de-privacidade',
  path: '/politica-de-privacidade',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const EscolherEmailRoute = EscolherEmailRouteImport.update({
  id: '/escolher-email',
  path: '/escolher-email',
  getParentRoute: () => rootRouteImport,
} as any)
const ContaExcluidaRoute = ContaExcluidaRouteImport.update({
  id: '/conta-excluida',
  path: '/conta-excluida',
  getParentRoute: () => rootRouteImport,
} as any)
const BoasVindasRoute = BoasVindasRouteImport.update({
  id: '/boas-vindas',
  path: '/boas-vindas',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VagasIndexRoute = VagasIndexRouteImport.update({
  id: '/vagas/',
  path: '/vagas/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgramasIndexRoute = ProgramasIndexRouteImport.update({
  id: '/programas/',
  path: '/programas/',
  getParentRoute: () => rootRouteImport,
} as any)
const PerfilIndexRoute = PerfilIndexRouteImport.update({
  id: '/perfil/',
  path: '/perfil/',
  getParentRoute: () => rootRouteImport,
} as any)
const OportunidadesIndexRoute = OportunidadesIndexRouteImport.update({
  id: '/oportunidades/',
  path: '/oportunidades/',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OnboardingRoute,
} as any)
const ModulosIndexRoute = ModulosIndexRouteImport.update({
  id: '/modulos/',
  path: '/modulos/',
  getParentRoute: () => rootRouteImport,
} as any)
const VagasMotivoReprovacaoEmailRoute =
  VagasMotivoReprovacaoEmailRouteImport.update({
    id: '/vagas/motivo-reprovacao-email',
    path: '/vagas/motivo-reprovacao-email',
    getParentRoute: () => rootRouteImport,
  } as any)
const VagasJobIdRoute = VagasJobIdRouteImport.update({
  id: '/vagas/$jobId',
  path: '/vagas/$jobId',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscriptionSuccessRoute = SubscriptionSuccessRouteImport.update({
  id: '/subscription/success',
  path: '/subscription/success',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgramasIdRoute = ProgramasIdRouteImport.update({
  id: '/programas/$id',
  path: '/programas/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PerfilTrocarSenhaRoute = PerfilTrocarSenhaRouteImport.update({
  id: '/perfil/trocar-senha',
  path: '/perfil/trocar-senha',
  getParentRoute: () => rootRouteImport,
} as any)
const PerfilDadosPessoaisRoute = PerfilDadosPessoaisRouteImport.update({
  id: '/perfil/dados-pessoais',
  path: '/perfil/dados-pessoais',
  getParentRoute: () => rootRouteImport,
} as any)
const PerfilCurriculoRoute = PerfilCurriculoRouteImport.update({
  id: '/perfil/curriculo',
  path: '/perfil/curriculo',
  getParentRoute: () => rootRouteImport,
} as any)
const PerfilContasVinculadasRoute = PerfilContasVinculadasRouteImport.update({
  id: '/perfil/contas-vinculadas',
  path: '/perfil/contas-vinculadas',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingVerificacaoRoute = OnboardingVerificacaoRouteImport.update({
  id: '/verificacao',
  path: '/verificacao',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingTermosRoute = OnboardingTermosRouteImport.update({
  id: '/termos',
  path: '/termos',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingLocalidadeRoute = OnboardingLocalidadeRouteImport.update({
  id: '/localidade',
  path: '/localidade',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingFormacaoRoute = OnboardingFormacaoRouteImport.update({
  id: '/formacao',
  path: '/formacao',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingCelularRoute = OnboardingCelularRouteImport.update({
  id: '/celular',
  path: '/celular',
  getParentRoute: () => OnboardingRoute,
} as any)
const ModulosConclusaoRoute = ModulosConclusaoRouteImport.update({
  id: '/modulos/conclusao',
  path: '/modulos/conclusao',
  getParentRoute: () => rootRouteImport,
} as any)
const ModulosModuleIdRoute = ModulosModuleIdRouteImport.update({
  id: '/modulos/$moduleId',
  path: '/modulos/$moduleId',
  getParentRoute: () => rootRouteImport,
} as any)
const VagasMotivoReprovacaoIndexRoute =
  VagasMotivoReprovacaoIndexRouteImport.update({
    id: '/vagas/motivo-reprovacao/',
    path: '/vagas/motivo-reprovacao/',
    getParentRoute: () => rootRouteImport,
  } as any)
const PerfilFotoIndexRoute = PerfilFotoIndexRouteImport.update({
  id: '/perfil/foto/',
  path: '/perfil/foto/',
  getParentRoute: () => rootRouteImport,
} as any)
const PerfilExcluirContaIndexRoute = PerfilExcluirContaIndexRouteImport.update({
  id: '/perfil/excluir-conta/',
  path: '/perfil/excluir-conta/',
  getParentRoute: () => rootRouteImport,
} as any)
const PerfilDadosPessoaisIndexRoute =
  PerfilDadosPessoaisIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PerfilDadosPessoaisRoute,
  } as any)
const PerfilCurriculoIndexRoute = PerfilCurriculoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PerfilCurriculoRoute,
} as any)
const VagasJobIdProcessoRoute = VagasJobIdProcessoRouteImport.update({
  id: '/vagas/$jobId_/processo',
  path: '/vagas/$jobId/processo',
  getParentRoute: () => rootRouteImport,
} as any)
const VagasJobIdInscricaoRoute = VagasJobIdInscricaoRouteImport.update({
  id: '/vagas/$jobId_/inscricao',
  path: '/vagas/$jobId/inscricao',
  getParentRoute: () => rootRouteImport,
} as any)
const PerfilFotoPreviewRoute = PerfilFotoPreviewRouteImport.update({
  id: '/perfil/foto/preview',
  path: '/perfil/foto/preview',
  getParentRoute: () => rootRouteImport,
} as any)
const PerfilEditarSelecionarFormacaoRoute =
  PerfilEditarSelecionarFormacaoRouteImport.update({
    id: '/perfil/editar/selecionar-formacao',
    path: '/perfil/editar/selecionar-formacao',
    getParentRoute: () => rootRouteImport,
  } as any)
const PerfilEditarEmailRoute = PerfilEditarEmailRouteImport.update({
  id: '/perfil/editar/email',
  path: '/perfil/editar/email',
  getParentRoute: () => rootRouteImport,
} as any)
const PerfilEditarAdicionarFormacaoRoute =
  PerfilEditarAdicionarFormacaoRouteImport.update({
    id: '/perfil/editar/adicionar-formacao',
    path: '/perfil/editar/adicionar-formacao',
    getParentRoute: () => rootRouteImport,
  } as any)
const PerfilEditarAdicionarCurriculoRoute =
  PerfilEditarAdicionarCurriculoRouteImport.update({
    id: '/perfil/editar/adicionar-curriculo',
    path: '/perfil/editar/adicionar-curriculo',
    getParentRoute: () => rootRouteImport,
  } as any)
const PerfilDadosPessoaisVerificacaoRoute =
  PerfilDadosPessoaisVerificacaoRouteImport.update({
    id: '/verificacao',
    path: '/verificacao',
    getParentRoute: () => PerfilDadosPessoaisRoute,
  } as any)
const PerfilDadosPessoaisLocalidadeRoute =
  PerfilDadosPessoaisLocalidadeRouteImport.update({
    id: '/localidade',
    path: '/localidade',
    getParentRoute: () => PerfilDadosPessoaisRoute,
  } as any)
const PerfilDadosPessoaisDiversidadeRoute =
  PerfilDadosPessoaisDiversidadeRouteImport.update({
    id: '/diversidade',
    path: '/diversidade',
    getParentRoute: () => PerfilDadosPessoaisRoute,
  } as any)
const PerfilDadosPessoaisCelularRoute =
  PerfilDadosPessoaisCelularRouteImport.update({
    id: '/celular',
    path: '/celular',
    getParentRoute: () => PerfilDadosPessoaisRoute,
  } as any)
const PerfilCurriculoSucessoRoute = PerfilCurriculoSucessoRouteImport.update({
  id: '/perfil/curriculo_/sucesso',
  path: '/perfil/curriculo/sucesso',
  getParentRoute: () => rootRouteImport,
} as any)
const PerfilCurriculoRevisarRoute = PerfilCurriculoRevisarRouteImport.update({
  id: '/revisar',
  path: '/revisar',
  getParentRoute: () => PerfilCurriculoRoute,
} as any)
const PerfilCurriculoPreviaRoute = PerfilCurriculoPreviaRouteImport.update({
  id: '/previa',
  path: '/previa',
  getParentRoute: () => PerfilCurriculoRoute,
} as any)
const PerfilCurriculoEnviarRoute = PerfilCurriculoEnviarRouteImport.update({
  id: '/enviar',
  path: '/enviar',
  getParentRoute: () => PerfilCurriculoRoute,
} as any)
const PerfilCurriculoEditarRoute = PerfilCurriculoEditarRouteImport.update({
  id: '/editar',
  path: '/editar',
  getParentRoute: () => PerfilCurriculoRoute,
} as any)
const PerfilCurriculoDadosPessoaisRoute =
  PerfilCurriculoDadosPessoaisRouteImport.update({
    id: '/dados-pessoais',
    path: '/dados-pessoais',
    getParentRoute: () => PerfilCurriculoRoute,
  } as any)
const ModulosModuleIdCurriculoRoute =
  ModulosModuleIdCurriculoRouteImport.update({
    id: '/modulos/$moduleId_/curriculo',
    path: '/modulos/$moduleId/curriculo',
    getParentRoute: () => rootRouteImport,
  } as any)
const VagasJobIdInscricaoIndexRoute =
  VagasJobIdInscricaoIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => VagasJobIdInscricaoRoute,
  } as any)
const PerfilEditarFormacoesIndexRoute =
  PerfilEditarFormacoesIndexRouteImport.update({
    id: '/perfil/editar/formacoes/',
    path: '/perfil/editar/formacoes/',
    getParentRoute: () => rootRouteImport,
  } as any)
const PerfilCurriculoSectionIndexRoute =
  PerfilCurriculoSectionIndexRouteImport.update({
    id: '/$section/',
    path: '/$section/',
    getParentRoute: () => PerfilCurriculoRoute,
  } as any)
const ModulosModuleIdCurriculoIndexRoute =
  ModulosModuleIdCurriculoIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ModulosModuleIdCurriculoRoute,
  } as any)
const VagasJobIdInscricaoRevisaoRoute =
  VagasJobIdInscricaoRevisaoRouteImport.update({
    id: '/revisao',
    path: '/revisao',
    getParentRoute: () => VagasJobIdInscricaoRoute,
  } as any)
const VagasJobIdInscricaoProgramaEmAndamentoRoute =
  VagasJobIdInscricaoProgramaEmAndamentoRouteImport.update({
    id: '/programa-em-andamento',
    path: '/programa-em-andamento',
    getParentRoute: () => VagasJobIdInscricaoRoute,
  } as any)
const VagasJobIdInscricaoFormularioRoute =
  VagasJobIdInscricaoFormularioRouteImport.update({
    id: '/formulario',
    path: '/formulario',
    getParentRoute: () => VagasJobIdInscricaoRoute,
  } as any)
const VagasJobIdInscricaoAreasDeAtuacaoRoute =
  VagasJobIdInscricaoAreasDeAtuacaoRouteImport.update({
    id: '/areas-de-atuacao',
    path: '/areas-de-atuacao',
    getParentRoute: () => VagasJobIdInscricaoRoute,
  } as any)
const VagasJobIdInscricaoAcessibilidadeRoute =
  VagasJobIdInscricaoAcessibilidadeRouteImport.update({
    id: '/acessibilidade',
    path: '/acessibilidade',
    getParentRoute: () => VagasJobIdInscricaoRoute,
  } as any)
const UsersUserIdSubscriptionOrderPriorityRoute =
  UsersUserIdSubscriptionOrderPriorityRouteImport.update({
    id: '/users/$userId/subscription/order-priority',
    path: '/users/$userId/subscription/order-priority',
    getParentRoute: () => rootRouteImport,
  } as any)
const UsersUserIdSubscriptionSubscriptionIdRoute =
  UsersUserIdSubscriptionSubscriptionIdRouteImport.update({
    id: '/users/$userId/subscription/$subscriptionId',
    path: '/users/$userId/subscription/$subscriptionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const PerfilEditarFormacoesIdRoute = PerfilEditarFormacoesIdRouteImport.update({
  id: '/perfil/editar/formacoes/$id',
  path: '/perfil/editar/formacoes/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PerfilCurriculoSectionNovaRoute =
  PerfilCurriculoSectionNovaRouteImport.update({
    id: '/$section/nova',
    path: '/$section/nova',
    getParentRoute: () => PerfilCurriculoRoute,
  } as any)
const ModulosModuleIdCurriculoRevisarRoute =
  ModulosModuleIdCurriculoRevisarRouteImport.update({
    id: '/revisar',
    path: '/revisar',
    getParentRoute: () => ModulosModuleIdCurriculoRoute,
  } as any)
const ModulosModuleIdCurriculoPreviaRoute =
  ModulosModuleIdCurriculoPreviaRouteImport.update({
    id: '/previa',
    path: '/previa',
    getParentRoute: () => ModulosModuleIdCurriculoRoute,
  } as any)
const ModulosModuleIdCurriculoEnviarRoute =
  ModulosModuleIdCurriculoEnviarRouteImport.update({
    id: '/enviar',
    path: '/enviar',
    getParentRoute: () => ModulosModuleIdCurriculoRoute,
  } as any)
const ModulosModuleIdCurriculoEditarRoute =
  ModulosModuleIdCurriculoEditarRouteImport.update({
    id: '/editar',
    path: '/editar',
    getParentRoute: () => ModulosModuleIdCurriculoRoute,
  } as any)
const ModulosModuleIdCurriculoDadosPessoaisRoute =
  ModulosModuleIdCurriculoDadosPessoaisRouteImport.update({
    id: '/dados-pessoais',
    path: '/dados-pessoais',
    getParentRoute: () => ModulosModuleIdCurriculoRoute,
  } as any)
const ModulosModuleIdCurriculoSectionIndexRoute =
  ModulosModuleIdCurriculoSectionIndexRouteImport.update({
    id: '/$section/',
    path: '/$section/',
    getParentRoute: () => ModulosModuleIdCurriculoRoute,
  } as any)
const PerfilCurriculoSectionItemIdEditarRoute =
  PerfilCurriculoSectionItemIdEditarRouteImport.update({
    id: '/$section/$itemId/editar',
    path: '/$section/$itemId/editar',
    getParentRoute: () => PerfilCurriculoRoute,
  } as any)
const ModulosModuleIdCurriculoSectionNovaRoute =
  ModulosModuleIdCurriculoSectionNovaRouteImport.update({
    id: '/$section/nova',
    path: '/$section/nova',
    getParentRoute: () => ModulosModuleIdCurriculoRoute,
  } as any)
const ModulosModuleIdCurriculoSectionItemIdEditarRoute =
  ModulosModuleIdCurriculoSectionItemIdEditarRouteImport.update({
    id: '/$section/$itemId/editar',
    path: '/$section/$itemId/editar',
    getParentRoute: () => ModulosModuleIdCurriculoRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/boas-vindas': typeof BoasVindasRoute
  '/conta-excluida': typeof ContaExcluidaRoute
  '/escolher-email': typeof EscolherEmailRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/politica-de-privacidade': typeof PoliticaDePrivacidadeRoute
  '/termos-de-uso': typeof TermosDeUsoRoute
  '/modulos/$moduleId': typeof ModulosModuleIdRoute
  '/modulos/conclusao': typeof ModulosConclusaoRoute
  '/onboarding/celular': typeof OnboardingCelularRoute
  '/onboarding/formacao': typeof OnboardingFormacaoRoute
  '/onboarding/localidade': typeof OnboardingLocalidadeRoute
  '/onboarding/termos': typeof OnboardingTermosRoute
  '/onboarding/verificacao': typeof OnboardingVerificacaoRoute
  '/perfil/contas-vinculadas': typeof PerfilContasVinculadasRoute
  '/perfil/curriculo': typeof PerfilCurriculoRouteWithChildren
  '/perfil/dados-pessoais': typeof PerfilDadosPessoaisRouteWithChildren
  '/perfil/trocar-senha': typeof PerfilTrocarSenhaRoute
  '/programas/$id': typeof ProgramasIdRoute
  '/subscription/success': typeof SubscriptionSuccessRoute
  '/vagas/$jobId': typeof VagasJobIdRoute
  '/vagas/motivo-reprovacao-email': typeof VagasMotivoReprovacaoEmailRoute
  '/modulos/': typeof ModulosIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/oportunidades/': typeof OportunidadesIndexRoute
  '/perfil/': typeof PerfilIndexRoute
  '/programas/': typeof ProgramasIndexRoute
  '/vagas/': typeof VagasIndexRoute
  '/modulos/$moduleId/curriculo': typeof ModulosModuleIdCurriculoRouteWithChildren
  '/perfil/curriculo/dados-pessoais': typeof PerfilCurriculoDadosPessoaisRoute
  '/perfil/curriculo/editar': typeof PerfilCurriculoEditarRoute
  '/perfil/curriculo/enviar': typeof PerfilCurriculoEnviarRoute
  '/perfil/curriculo/previa': typeof PerfilCurriculoPreviaRoute
  '/perfil/curriculo/revisar': typeof PerfilCurriculoRevisarRoute
  '/perfil/curriculo/sucesso': typeof PerfilCurriculoSucessoRoute
  '/perfil/dados-pessoais/celular': typeof PerfilDadosPessoaisCelularRoute
  '/perfil/dados-pessoais/diversidade': typeof PerfilDadosPessoaisDiversidadeRoute
  '/perfil/dados-pessoais/localidade': typeof PerfilDadosPessoaisLocalidadeRoute
  '/perfil/dados-pessoais/verificacao': typeof PerfilDadosPessoaisVerificacaoRoute
  '/perfil/editar/adicionar-curriculo': typeof PerfilEditarAdicionarCurriculoRoute
  '/perfil/editar/adicionar-formacao': typeof PerfilEditarAdicionarFormacaoRoute
  '/perfil/editar/email': typeof PerfilEditarEmailRoute
  '/perfil/editar/selecionar-formacao': typeof PerfilEditarSelecionarFormacaoRoute
  '/perfil/foto/preview': typeof PerfilFotoPreviewRoute
  '/vagas/$jobId/inscricao': typeof VagasJobIdInscricaoRouteWithChildren
  '/vagas/$jobId/processo': typeof VagasJobIdProcessoRoute
  '/perfil/curriculo/': typeof PerfilCurriculoIndexRoute
  '/perfil/dados-pessoais/': typeof PerfilDadosPessoaisIndexRoute
  '/perfil/excluir-conta/': typeof PerfilExcluirContaIndexRoute
  '/perfil/foto/': typeof PerfilFotoIndexRoute
  '/vagas/motivo-reprovacao/': typeof VagasMotivoReprovacaoIndexRoute
  '/modulos/$moduleId/curriculo/dados-pessoais': typeof ModulosModuleIdCurriculoDadosPessoaisRoute
  '/modulos/$moduleId/curriculo/editar': typeof ModulosModuleIdCurriculoEditarRoute
  '/modulos/$moduleId/curriculo/enviar': typeof ModulosModuleIdCurriculoEnviarRoute
  '/modulos/$moduleId/curriculo/previa': typeof ModulosModuleIdCurriculoPreviaRoute
  '/modulos/$moduleId/curriculo/revisar': typeof ModulosModuleIdCurriculoRevisarRoute
  '/perfil/curriculo/$section/nova': typeof PerfilCurriculoSectionNovaRoute
  '/perfil/editar/formacoes/$id': typeof PerfilEditarFormacoesIdRoute
  '/users/$userId/subscription/$subscriptionId': typeof UsersUserIdSubscriptionSubscriptionIdRoute
  '/users/$userId/subscription/order-priority': typeof UsersUserIdSubscriptionOrderPriorityRoute
  '/vagas/$jobId/inscricao/acessibilidade': typeof VagasJobIdInscricaoAcessibilidadeRoute
  '/vagas/$jobId/inscricao/areas-de-atuacao': typeof VagasJobIdInscricaoAreasDeAtuacaoRoute
  '/vagas/$jobId/inscricao/formulario': typeof VagasJobIdInscricaoFormularioRoute
  '/vagas/$jobId/inscricao/programa-em-andamento': typeof VagasJobIdInscricaoProgramaEmAndamentoRoute
  '/vagas/$jobId/inscricao/revisao': typeof VagasJobIdInscricaoRevisaoRoute
  '/modulos/$moduleId/curriculo/': typeof ModulosModuleIdCurriculoIndexRoute
  '/perfil/curriculo/$section/': typeof PerfilCurriculoSectionIndexRoute
  '/perfil/editar/formacoes/': typeof PerfilEditarFormacoesIndexRoute
  '/vagas/$jobId/inscricao/': typeof VagasJobIdInscricaoIndexRoute
  '/modulos/$moduleId/curriculo/$section/nova': typeof ModulosModuleIdCurriculoSectionNovaRoute
  '/perfil/curriculo/$section/$itemId/editar': typeof PerfilCurriculoSectionItemIdEditarRoute
  '/modulos/$moduleId/curriculo/$section/': typeof ModulosModuleIdCurriculoSectionIndexRoute
  '/modulos/$moduleId/curriculo/$section/$itemId/editar': typeof ModulosModuleIdCurriculoSectionItemIdEditarRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/boas-vindas': typeof BoasVindasRoute
  '/conta-excluida': typeof ContaExcluidaRoute
  '/escolher-email': typeof EscolherEmailRoute
  '/politica-de-privacidade': typeof PoliticaDePrivacidadeRoute
  '/termos-de-uso': typeof TermosDeUsoRoute
  '/modulos/$moduleId': typeof ModulosModuleIdRoute
  '/modulos/conclusao': typeof ModulosConclusaoRoute
  '/onboarding/celular': typeof OnboardingCelularRoute
  '/onboarding/formacao': typeof OnboardingFormacaoRoute
  '/onboarding/localidade': typeof OnboardingLocalidadeRoute
  '/onboarding/termos': typeof OnboardingTermosRoute
  '/onboarding/verificacao': typeof OnboardingVerificacaoRoute
  '/perfil/contas-vinculadas': typeof PerfilContasVinculadasRoute
  '/perfil/trocar-senha': typeof PerfilTrocarSenhaRoute
  '/programas/$id': typeof ProgramasIdRoute
  '/subscription/success': typeof SubscriptionSuccessRoute
  '/vagas/$jobId': typeof VagasJobIdRoute
  '/vagas/motivo-reprovacao-email': typeof VagasMotivoReprovacaoEmailRoute
  '/modulos': typeof ModulosIndexRoute
  '/onboarding': typeof OnboardingIndexRoute
  '/oportunidades': typeof OportunidadesIndexRoute
  '/perfil': typeof PerfilIndexRoute
  '/programas': typeof ProgramasIndexRoute
  '/vagas': typeof VagasIndexRoute
  '/perfil/curriculo/dados-pessoais': typeof PerfilCurriculoDadosPessoaisRoute
  '/perfil/curriculo/editar': typeof PerfilCurriculoEditarRoute
  '/perfil/curriculo/enviar': typeof PerfilCurriculoEnviarRoute
  '/perfil/curriculo/previa': typeof PerfilCurriculoPreviaRoute
  '/perfil/curriculo/revisar': typeof PerfilCurriculoRevisarRoute
  '/perfil/curriculo/sucesso': typeof PerfilCurriculoSucessoRoute
  '/perfil/dados-pessoais/celular': typeof PerfilDadosPessoaisCelularRoute
  '/perfil/dados-pessoais/diversidade': typeof PerfilDadosPessoaisDiversidadeRoute
  '/perfil/dados-pessoais/localidade': typeof PerfilDadosPessoaisLocalidadeRoute
  '/perfil/dados-pessoais/verificacao': typeof PerfilDadosPessoaisVerificacaoRoute
  '/perfil/editar/adicionar-curriculo': typeof PerfilEditarAdicionarCurriculoRoute
  '/perfil/editar/adicionar-formacao': typeof PerfilEditarAdicionarFormacaoRoute
  '/perfil/editar/email': typeof PerfilEditarEmailRoute
  '/perfil/editar/selecionar-formacao': typeof PerfilEditarSelecionarFormacaoRoute
  '/perfil/foto/preview': typeof PerfilFotoPreviewRoute
  '/vagas/$jobId/processo': typeof VagasJobIdProcessoRoute
  '/perfil/curriculo': typeof PerfilCurriculoIndexRoute
  '/perfil/dados-pessoais': typeof PerfilDadosPessoaisIndexRoute
  '/perfil/excluir-conta': typeof PerfilExcluirContaIndexRoute
  '/perfil/foto': typeof PerfilFotoIndexRoute
  '/vagas/motivo-reprovacao': typeof VagasMotivoReprovacaoIndexRoute
  '/modulos/$moduleId/curriculo/dados-pessoais': typeof ModulosModuleIdCurriculoDadosPessoaisRoute
  '/modulos/$moduleId/curriculo/editar': typeof ModulosModuleIdCurriculoEditarRoute
  '/modulos/$moduleId/curriculo/enviar': typeof ModulosModuleIdCurriculoEnviarRoute
  '/modulos/$moduleId/curriculo/previa': typeof ModulosModuleIdCurriculoPreviaRoute
  '/modulos/$moduleId/curriculo/revisar': typeof ModulosModuleIdCurriculoRevisarRoute
  '/perfil/curriculo/$section/nova': typeof PerfilCurriculoSectionNovaRoute
  '/perfil/editar/formacoes/$id': typeof PerfilEditarFormacoesIdRoute
  '/users/$userId/subscription/$subscriptionId': typeof UsersUserIdSubscriptionSubscriptionIdRoute
  '/users/$userId/subscription/order-priority': typeof UsersUserIdSubscriptionOrderPriorityRoute
  '/vagas/$jobId/inscricao/acessibilidade': typeof VagasJobIdInscricaoAcessibilidadeRoute
  '/vagas/$jobId/inscricao/areas-de-atuacao': typeof VagasJobIdInscricaoAreasDeAtuacaoRoute
  '/vagas/$jobId/inscricao/formulario': typeof VagasJobIdInscricaoFormularioRoute
  '/vagas/$jobId/inscricao/programa-em-andamento': typeof VagasJobIdInscricaoProgramaEmAndamentoRoute
  '/vagas/$jobId/inscricao/revisao': typeof VagasJobIdInscricaoRevisaoRoute
  '/modulos/$moduleId/curriculo': typeof ModulosModuleIdCurriculoIndexRoute
  '/perfil/curriculo/$section': typeof PerfilCurriculoSectionIndexRoute
  '/perfil/editar/formacoes': typeof PerfilEditarFormacoesIndexRoute
  '/vagas/$jobId/inscricao': typeof VagasJobIdInscricaoIndexRoute
  '/modulos/$moduleId/curriculo/$section/nova': typeof ModulosModuleIdCurriculoSectionNovaRoute
  '/perfil/curriculo/$section/$itemId/editar': typeof PerfilCurriculoSectionItemIdEditarRoute
  '/modulos/$moduleId/curriculo/$section': typeof ModulosModuleIdCurriculoSectionIndexRoute
  '/modulos/$moduleId/curriculo/$section/$itemId/editar': typeof ModulosModuleIdCurriculoSectionItemIdEditarRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/boas-vindas': typeof BoasVindasRoute
  '/conta-excluida': typeof ContaExcluidaRoute
  '/escolher-email': typeof EscolherEmailRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/politica-de-privacidade': typeof PoliticaDePrivacidadeRoute
  '/termos-de-uso': typeof TermosDeUsoRoute
  '/modulos/$moduleId': typeof ModulosModuleIdRoute
  '/modulos/conclusao': typeof ModulosConclusaoRoute
  '/onboarding/celular': typeof OnboardingCelularRoute
  '/onboarding/formacao': typeof OnboardingFormacaoRoute
  '/onboarding/localidade': typeof OnboardingLocalidadeRoute
  '/onboarding/termos': typeof OnboardingTermosRoute
  '/onboarding/verificacao': typeof OnboardingVerificacaoRoute
  '/perfil/contas-vinculadas': typeof PerfilContasVinculadasRoute
  '/perfil/curriculo': typeof PerfilCurriculoRouteWithChildren
  '/perfil/dados-pessoais': typeof PerfilDadosPessoaisRouteWithChildren
  '/perfil/trocar-senha': typeof PerfilTrocarSenhaRoute
  '/programas/$id': typeof ProgramasIdRoute
  '/subscription/success': typeof SubscriptionSuccessRoute
  '/vagas/$jobId': typeof VagasJobIdRoute
  '/vagas/motivo-reprovacao-email': typeof VagasMotivoReprovacaoEmailRoute
  '/modulos/': typeof ModulosIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/oportunidades/': typeof OportunidadesIndexRoute
  '/perfil/': typeof PerfilIndexRoute
  '/programas/': typeof ProgramasIndexRoute
  '/vagas/': typeof VagasIndexRoute
  '/modulos/$moduleId_/curriculo': typeof ModulosModuleIdCurriculoRouteWithChildren
  '/perfil/curriculo/dados-pessoais': typeof PerfilCurriculoDadosPessoaisRoute
  '/perfil/curriculo/editar': typeof PerfilCurriculoEditarRoute
  '/perfil/curriculo/enviar': typeof PerfilCurriculoEnviarRoute
  '/perfil/curriculo/previa': typeof PerfilCurriculoPreviaRoute
  '/perfil/curriculo/revisar': typeof PerfilCurriculoRevisarRoute
  '/perfil/curriculo_/sucesso': typeof PerfilCurriculoSucessoRoute
  '/perfil/dados-pessoais/celular': typeof PerfilDadosPessoaisCelularRoute
  '/perfil/dados-pessoais/diversidade': typeof PerfilDadosPessoaisDiversidadeRoute
  '/perfil/dados-pessoais/localidade': typeof PerfilDadosPessoaisLocalidadeRoute
  '/perfil/dados-pessoais/verificacao': typeof PerfilDadosPessoaisVerificacaoRoute
  '/perfil/editar/adicionar-curriculo': typeof PerfilEditarAdicionarCurriculoRoute
  '/perfil/editar/adicionar-formacao': typeof PerfilEditarAdicionarFormacaoRoute
  '/perfil/editar/email': typeof PerfilEditarEmailRoute
  '/perfil/editar/selecionar-formacao': typeof PerfilEditarSelecionarFormacaoRoute
  '/perfil/foto/preview': typeof PerfilFotoPreviewRoute
  '/vagas/$jobId_/inscricao': typeof VagasJobIdInscricaoRouteWithChildren
  '/vagas/$jobId_/processo': typeof VagasJobIdProcessoRoute
  '/perfil/curriculo/': typeof PerfilCurriculoIndexRoute
  '/perfil/dados-pessoais/': typeof PerfilDadosPessoaisIndexRoute
  '/perfil/excluir-conta/': typeof PerfilExcluirContaIndexRoute
  '/perfil/foto/': typeof PerfilFotoIndexRoute
  '/vagas/motivo-reprovacao/': typeof VagasMotivoReprovacaoIndexRoute
  '/modulos/$moduleId_/curriculo/dados-pessoais': typeof ModulosModuleIdCurriculoDadosPessoaisRoute
  '/modulos/$moduleId_/curriculo/editar': typeof ModulosModuleIdCurriculoEditarRoute
  '/modulos/$moduleId_/curriculo/enviar': typeof ModulosModuleIdCurriculoEnviarRoute
  '/modulos/$moduleId_/curriculo/previa': typeof ModulosModuleIdCurriculoPreviaRoute
  '/modulos/$moduleId_/curriculo/revisar': typeof ModulosModuleIdCurriculoRevisarRoute
  '/perfil/curriculo/$section/nova': typeof PerfilCurriculoSectionNovaRoute
  '/perfil/editar/formacoes/$id': typeof PerfilEditarFormacoesIdRoute
  '/users/$userId/subscription/$subscriptionId': typeof UsersUserIdSubscriptionSubscriptionIdRoute
  '/users/$userId/subscription/order-priority': typeof UsersUserIdSubscriptionOrderPriorityRoute
  '/vagas/$jobId_/inscricao/acessibilidade': typeof VagasJobIdInscricaoAcessibilidadeRoute
  '/vagas/$jobId_/inscricao/areas-de-atuacao': typeof VagasJobIdInscricaoAreasDeAtuacaoRoute
  '/vagas/$jobId_/inscricao/formulario': typeof VagasJobIdInscricaoFormularioRoute
  '/vagas/$jobId_/inscricao/programa-em-andamento': typeof VagasJobIdInscricaoProgramaEmAndamentoRoute
  '/vagas/$jobId_/inscricao/revisao': typeof VagasJobIdInscricaoRevisaoRoute
  '/modulos/$moduleId_/curriculo/': typeof ModulosModuleIdCurriculoIndexRoute
  '/perfil/curriculo/$section/': typeof PerfilCurriculoSectionIndexRoute
  '/perfil/editar/formacoes/': typeof PerfilEditarFormacoesIndexRoute
  '/vagas/$jobId_/inscricao/': typeof VagasJobIdInscricaoIndexRoute
  '/modulos/$moduleId_/curriculo/$section/nova': typeof ModulosModuleIdCurriculoSectionNovaRoute
  '/perfil/curriculo/$section/$itemId/editar': typeof PerfilCurriculoSectionItemIdEditarRoute
  '/modulos/$moduleId_/curriculo/$section/': typeof ModulosModuleIdCurriculoSectionIndexRoute
  '/modulos/$moduleId_/curriculo/$section/$itemId/editar': typeof ModulosModuleIdCurriculoSectionItemIdEditarRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/boas-vindas'
    | '/conta-excluida'
    | '/escolher-email'
    | '/onboarding'
    | '/politica-de-privacidade'
    | '/termos-de-uso'
    | '/modulos/$moduleId'
    | '/modulos/conclusao'
    | '/onboarding/celular'
    | '/onboarding/formacao'
    | '/onboarding/localidade'
    | '/onboarding/termos'
    | '/onboarding/verificacao'
    | '/perfil/contas-vinculadas'
    | '/perfil/curriculo'
    | '/perfil/dados-pessoais'
    | '/perfil/trocar-senha'
    | '/programas/$id'
    | '/subscription/success'
    | '/vagas/$jobId'
    | '/vagas/motivo-reprovacao-email'
    | '/modulos/'
    | '/onboarding/'
    | '/oportunidades/'
    | '/perfil/'
    | '/programas/'
    | '/vagas/'
    | '/modulos/$moduleId/curriculo'
    | '/perfil/curriculo/dados-pessoais'
    | '/perfil/curriculo/editar'
    | '/perfil/curriculo/enviar'
    | '/perfil/curriculo/previa'
    | '/perfil/curriculo/revisar'
    | '/perfil/curriculo/sucesso'
    | '/perfil/dados-pessoais/celular'
    | '/perfil/dados-pessoais/diversidade'
    | '/perfil/dados-pessoais/localidade'
    | '/perfil/dados-pessoais/verificacao'
    | '/perfil/editar/adicionar-curriculo'
    | '/perfil/editar/adicionar-formacao'
    | '/perfil/editar/email'
    | '/perfil/editar/selecionar-formacao'
    | '/perfil/foto/preview'
    | '/vagas/$jobId/inscricao'
    | '/vagas/$jobId/processo'
    | '/perfil/curriculo/'
    | '/perfil/dados-pessoais/'
    | '/perfil/excluir-conta/'
    | '/perfil/foto/'
    | '/vagas/motivo-reprovacao/'
    | '/modulos/$moduleId/curriculo/dados-pessoais'
    | '/modulos/$moduleId/curriculo/editar'
    | '/modulos/$moduleId/curriculo/enviar'
    | '/modulos/$moduleId/curriculo/previa'
    | '/modulos/$moduleId/curriculo/revisar'
    | '/perfil/curriculo/$section/nova'
    | '/perfil/editar/formacoes/$id'
    | '/users/$userId/subscription/$subscriptionId'
    | '/users/$userId/subscription/order-priority'
    | '/vagas/$jobId/inscricao/acessibilidade'
    | '/vagas/$jobId/inscricao/areas-de-atuacao'
    | '/vagas/$jobId/inscricao/formulario'
    | '/vagas/$jobId/inscricao/programa-em-andamento'
    | '/vagas/$jobId/inscricao/revisao'
    | '/modulos/$moduleId/curriculo/'
    | '/perfil/curriculo/$section/'
    | '/perfil/editar/formacoes/'
    | '/vagas/$jobId/inscricao/'
    | '/modulos/$moduleId/curriculo/$section/nova'
    | '/perfil/curriculo/$section/$itemId/editar'
    | '/modulos/$moduleId/curriculo/$section/'
    | '/modulos/$moduleId/curriculo/$section/$itemId/editar'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/boas-vindas'
    | '/conta-excluida'
    | '/escolher-email'
    | '/politica-de-privacidade'
    | '/termos-de-uso'
    | '/modulos/$moduleId'
    | '/modulos/conclusao'
    | '/onboarding/celular'
    | '/onboarding/formacao'
    | '/onboarding/localidade'
    | '/onboarding/termos'
    | '/onboarding/verificacao'
    | '/perfil/contas-vinculadas'
    | '/perfil/trocar-senha'
    | '/programas/$id'
    | '/subscription/success'
    | '/vagas/$jobId'
    | '/vagas/motivo-reprovacao-email'
    | '/modulos'
    | '/onboarding'
    | '/oportunidades'
    | '/perfil'
    | '/programas'
    | '/vagas'
    | '/perfil/curriculo/dados-pessoais'
    | '/perfil/curriculo/editar'
    | '/perfil/curriculo/enviar'
    | '/perfil/curriculo/previa'
    | '/perfil/curriculo/revisar'
    | '/perfil/curriculo/sucesso'
    | '/perfil/dados-pessoais/celular'
    | '/perfil/dados-pessoais/diversidade'
    | '/perfil/dados-pessoais/localidade'
    | '/perfil/dados-pessoais/verificacao'
    | '/perfil/editar/adicionar-curriculo'
    | '/perfil/editar/adicionar-formacao'
    | '/perfil/editar/email'
    | '/perfil/editar/selecionar-formacao'
    | '/perfil/foto/preview'
    | '/vagas/$jobId/processo'
    | '/perfil/curriculo'
    | '/perfil/dados-pessoais'
    | '/perfil/excluir-conta'
    | '/perfil/foto'
    | '/vagas/motivo-reprovacao'
    | '/modulos/$moduleId/curriculo/dados-pessoais'
    | '/modulos/$moduleId/curriculo/editar'
    | '/modulos/$moduleId/curriculo/enviar'
    | '/modulos/$moduleId/curriculo/previa'
    | '/modulos/$moduleId/curriculo/revisar'
    | '/perfil/curriculo/$section/nova'
    | '/perfil/editar/formacoes/$id'
    | '/users/$userId/subscription/$subscriptionId'
    | '/users/$userId/subscription/order-priority'
    | '/vagas/$jobId/inscricao/acessibilidade'
    | '/vagas/$jobId/inscricao/areas-de-atuacao'
    | '/vagas/$jobId/inscricao/formulario'
    | '/vagas/$jobId/inscricao/programa-em-andamento'
    | '/vagas/$jobId/inscricao/revisao'
    | '/modulos/$moduleId/curriculo'
    | '/perfil/curriculo/$section'
    | '/perfil/editar/formacoes'
    | '/vagas/$jobId/inscricao'
    | '/modulos/$moduleId/curriculo/$section/nova'
    | '/perfil/curriculo/$section/$itemId/editar'
    | '/modulos/$moduleId/curriculo/$section'
    | '/modulos/$moduleId/curriculo/$section/$itemId/editar'
  id:
    | '__root__'
    | '/'
    | '/boas-vindas'
    | '/conta-excluida'
    | '/escolher-email'
    | '/onboarding'
    | '/politica-de-privacidade'
    | '/termos-de-uso'
    | '/modulos/$moduleId'
    | '/modulos/conclusao'
    | '/onboarding/celular'
    | '/onboarding/formacao'
    | '/onboarding/localidade'
    | '/onboarding/termos'
    | '/onboarding/verificacao'
    | '/perfil/contas-vinculadas'
    | '/perfil/curriculo'
    | '/perfil/dados-pessoais'
    | '/perfil/trocar-senha'
    | '/programas/$id'
    | '/subscription/success'
    | '/vagas/$jobId'
    | '/vagas/motivo-reprovacao-email'
    | '/modulos/'
    | '/onboarding/'
    | '/oportunidades/'
    | '/perfil/'
    | '/programas/'
    | '/vagas/'
    | '/modulos/$moduleId_/curriculo'
    | '/perfil/curriculo/dados-pessoais'
    | '/perfil/curriculo/editar'
    | '/perfil/curriculo/enviar'
    | '/perfil/curriculo/previa'
    | '/perfil/curriculo/revisar'
    | '/perfil/curriculo_/sucesso'
    | '/perfil/dados-pessoais/celular'
    | '/perfil/dados-pessoais/diversidade'
    | '/perfil/dados-pessoais/localidade'
    | '/perfil/dados-pessoais/verificacao'
    | '/perfil/editar/adicionar-curriculo'
    | '/perfil/editar/adicionar-formacao'
    | '/perfil/editar/email'
    | '/perfil/editar/selecionar-formacao'
    | '/perfil/foto/preview'
    | '/vagas/$jobId_/inscricao'
    | '/vagas/$jobId_/processo'
    | '/perfil/curriculo/'
    | '/perfil/dados-pessoais/'
    | '/perfil/excluir-conta/'
    | '/perfil/foto/'
    | '/vagas/motivo-reprovacao/'
    | '/modulos/$moduleId_/curriculo/dados-pessoais'
    | '/modulos/$moduleId_/curriculo/editar'
    | '/modulos/$moduleId_/curriculo/enviar'
    | '/modulos/$moduleId_/curriculo/previa'
    | '/modulos/$moduleId_/curriculo/revisar'
    | '/perfil/curriculo/$section/nova'
    | '/perfil/editar/formacoes/$id'
    | '/users/$userId/subscription/$subscriptionId'
    | '/users/$userId/subscription/order-priority'
    | '/vagas/$jobId_/inscricao/acessibilidade'
    | '/vagas/$jobId_/inscricao/areas-de-atuacao'
    | '/vagas/$jobId_/inscricao/formulario'
    | '/vagas/$jobId_/inscricao/programa-em-andamento'
    | '/vagas/$jobId_/inscricao/revisao'
    | '/modulos/$moduleId_/curriculo/'
    | '/perfil/curriculo/$section/'
    | '/perfil/editar/formacoes/'
    | '/vagas/$jobId_/inscricao/'
    | '/modulos/$moduleId_/curriculo/$section/nova'
    | '/perfil/curriculo/$section/$itemId/editar'
    | '/modulos/$moduleId_/curriculo/$section/'
    | '/modulos/$moduleId_/curriculo/$section/$itemId/editar'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BoasVindasRoute: typeof BoasVindasRoute
  ContaExcluidaRoute: typeof ContaExcluidaRoute
  EscolherEmailRoute: typeof EscolherEmailRoute
  OnboardingRoute: typeof OnboardingRouteWithChildren
  PoliticaDePrivacidadeRoute: typeof PoliticaDePrivacidadeRoute
  TermosDeUsoRoute: typeof TermosDeUsoRoute
  ModulosModuleIdRoute: typeof ModulosModuleIdRoute
  ModulosConclusaoRoute: typeof ModulosConclusaoRoute
  PerfilContasVinculadasRoute: typeof PerfilContasVinculadasRoute
  PerfilCurriculoRoute: typeof PerfilCurriculoRouteWithChildren
  PerfilDadosPessoaisRoute: typeof PerfilDadosPessoaisRouteWithChildren
  PerfilTrocarSenhaRoute: typeof PerfilTrocarSenhaRoute
  ProgramasIdRoute: typeof ProgramasIdRoute
  SubscriptionSuccessRoute: typeof SubscriptionSuccessRoute
  VagasJobIdRoute: typeof VagasJobIdRoute
  VagasMotivoReprovacaoEmailRoute: typeof VagasMotivoReprovacaoEmailRoute
  ModulosIndexRoute: typeof ModulosIndexRoute
  OportunidadesIndexRoute: typeof OportunidadesIndexRoute
  PerfilIndexRoute: typeof PerfilIndexRoute
  ProgramasIndexRoute: typeof ProgramasIndexRoute
  VagasIndexRoute: typeof VagasIndexRoute
  ModulosModuleIdCurriculoRoute: typeof ModulosModuleIdCurriculoRouteWithChildren
  PerfilCurriculoSucessoRoute: typeof PerfilCurriculoSucessoRoute
  PerfilEditarAdicionarCurriculoRoute: typeof PerfilEditarAdicionarCurriculoRoute
  PerfilEditarAdicionarFormacaoRoute: typeof PerfilEditarAdicionarFormacaoRoute
  PerfilEditarEmailRoute: typeof PerfilEditarEmailRoute
  PerfilEditarSelecionarFormacaoRoute: typeof PerfilEditarSelecionarFormacaoRoute
  PerfilFotoPreviewRoute: typeof PerfilFotoPreviewRoute
  VagasJobIdInscricaoRoute: typeof VagasJobIdInscricaoRouteWithChildren
  VagasJobIdProcessoRoute: typeof VagasJobIdProcessoRoute
  PerfilExcluirContaIndexRoute: typeof PerfilExcluirContaIndexRoute
  PerfilFotoIndexRoute: typeof PerfilFotoIndexRoute
  VagasMotivoReprovacaoIndexRoute: typeof VagasMotivoReprovacaoIndexRoute
  PerfilEditarFormacoesIdRoute: typeof PerfilEditarFormacoesIdRoute
  UsersUserIdSubscriptionSubscriptionIdRoute: typeof UsersUserIdSubscriptionSubscriptionIdRoute
  UsersUserIdSubscriptionOrderPriorityRoute: typeof UsersUserIdSubscriptionOrderPriorityRoute
  PerfilEditarFormacoesIndexRoute: typeof PerfilEditarFormacoesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/termos-de-uso': {
      id: '/termos-de-uso'
      path: '/termos-de-uso'
      fullPath: '/termos-de-uso'
      preLoaderRoute: typeof TermosDeUsoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/politica-de-privacidade': {
      id: '/politica-de-privacidade'
      path: '/politica-de-privacidade'
      fullPath: '/politica-de-privacidade'
      preLoaderRoute: typeof PoliticaDePrivacidadeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/escolher-email': {
      id: '/escolher-email'
      path: '/escolher-email'
      fullPath: '/escolher-email'
      preLoaderRoute: typeof EscolherEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conta-excluida': {
      id: '/conta-excluida'
      path: '/conta-excluida'
      fullPath: '/conta-excluida'
      preLoaderRoute: typeof ContaExcluidaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/boas-vindas': {
      id: '/boas-vindas'
      path: '/boas-vindas'
      fullPath: '/boas-vindas'
      preLoaderRoute: typeof BoasVindasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vagas/': {
      id: '/vagas/'
      path: '/vagas'
      fullPath: '/vagas/'
      preLoaderRoute: typeof VagasIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/programas/': {
      id: '/programas/'
      path: '/programas'
      fullPath: '/programas/'
      preLoaderRoute: typeof ProgramasIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/perfil/': {
      id: '/perfil/'
      path: '/perfil'
      fullPath: '/perfil/'
      preLoaderRoute: typeof PerfilIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oportunidades/': {
      id: '/oportunidades/'
      path: '/oportunidades'
      fullPath: '/oportunidades/'
      preLoaderRoute: typeof OportunidadesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/modulos/': {
      id: '/modulos/'
      path: '/modulos'
      fullPath: '/modulos/'
      preLoaderRoute: typeof ModulosIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vagas/motivo-reprovacao-email': {
      id: '/vagas/motivo-reprovacao-email'
      path: '/vagas/motivo-reprovacao-email'
      fullPath: '/vagas/motivo-reprovacao-email'
      preLoaderRoute: typeof VagasMotivoReprovacaoEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vagas/$jobId': {
      id: '/vagas/$jobId'
      path: '/vagas/$jobId'
      fullPath: '/vagas/$jobId'
      preLoaderRoute: typeof VagasJobIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscription/success': {
      id: '/subscription/success'
      path: '/subscription/success'
      fullPath: '/subscription/success'
      preLoaderRoute: typeof SubscriptionSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/programas/$id': {
      id: '/programas/$id'
      path: '/programas/$id'
      fullPath: '/programas/$id'
      preLoaderRoute: typeof ProgramasIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/perfil/trocar-senha': {
      id: '/perfil/trocar-senha'
      path: '/perfil/trocar-senha'
      fullPath: '/perfil/trocar-senha'
      preLoaderRoute: typeof PerfilTrocarSenhaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/perfil/dados-pessoais': {
      id: '/perfil/dados-pessoais'
      path: '/perfil/dados-pessoais'
      fullPath: '/perfil/dados-pessoais'
      preLoaderRoute: typeof PerfilDadosPessoaisRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/perfil/curriculo': {
      id: '/perfil/curriculo'
      path: '/perfil/curriculo'
      fullPath: '/perfil/curriculo'
      preLoaderRoute: typeof PerfilCurriculoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/perfil/contas-vinculadas': {
      id: '/perfil/contas-vinculadas'
      path: '/perfil/contas-vinculadas'
      fullPath: '/perfil/contas-vinculadas'
      preLoaderRoute: typeof PerfilContasVinculadasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/verificacao': {
      id: '/onboarding/verificacao'
      path: '/verificacao'
      fullPath: '/onboarding/verificacao'
      preLoaderRoute: typeof OnboardingVerificacaoRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/termos': {
      id: '/onboarding/termos'
      path: '/termos'
      fullPath: '/onboarding/termos'
      preLoaderRoute: typeof OnboardingTermosRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/localidade': {
      id: '/onboarding/localidade'
      path: '/localidade'
      fullPath: '/onboarding/localidade'
      preLoaderRoute: typeof OnboardingLocalidadeRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/formacao': {
      id: '/onboarding/formacao'
      path: '/formacao'
      fullPath: '/onboarding/formacao'
      preLoaderRoute: typeof OnboardingFormacaoRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/celular': {
      id: '/onboarding/celular'
      path: '/celular'
      fullPath: '/onboarding/celular'
      preLoaderRoute: typeof OnboardingCelularRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/modulos/conclusao': {
      id: '/modulos/conclusao'
      path: '/modulos/conclusao'
      fullPath: '/modulos/conclusao'
      preLoaderRoute: typeof ModulosConclusaoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/modulos/$moduleId': {
      id: '/modulos/$moduleId'
      path: '/modulos/$moduleId'
      fullPath: '/modulos/$moduleId'
      preLoaderRoute: typeof ModulosModuleIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vagas/motivo-reprovacao/': {
      id: '/vagas/motivo-reprovacao/'
      path: '/vagas/motivo-reprovacao'
      fullPath: '/vagas/motivo-reprovacao/'
      preLoaderRoute: typeof VagasMotivoReprovacaoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/perfil/foto/': {
      id: '/perfil/foto/'
      path: '/perfil/foto'
      fullPath: '/perfil/foto/'
      preLoaderRoute: typeof PerfilFotoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/perfil/excluir-conta/': {
      id: '/perfil/excluir-conta/'
      path: '/perfil/excluir-conta'
      fullPath: '/perfil/excluir-conta/'
      preLoaderRoute: typeof PerfilExcluirContaIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/perfil/dados-pessoais/': {
      id: '/perfil/dados-pessoais/'
      path: '/'
      fullPath: '/perfil/dados-pessoais/'
      preLoaderRoute: typeof PerfilDadosPessoaisIndexRouteImport
      parentRoute: typeof PerfilDadosPessoaisRoute
    }
    '/perfil/curriculo/': {
      id: '/perfil/curriculo/'
      path: '/'
      fullPath: '/perfil/curriculo/'
      preLoaderRoute: typeof PerfilCurriculoIndexRouteImport
      parentRoute: typeof PerfilCurriculoRoute
    }
    '/vagas/$jobId_/processo': {
      id: '/vagas/$jobId_/processo'
      path: '/vagas/$jobId/processo'
      fullPath: '/vagas/$jobId/processo'
      preLoaderRoute: typeof VagasJobIdProcessoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vagas/$jobId_/inscricao': {
      id: '/vagas/$jobId_/inscricao'
      path: '/vagas/$jobId/inscricao'
      fullPath: '/vagas/$jobId/inscricao'
      preLoaderRoute: typeof VagasJobIdInscricaoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/perfil/foto/preview': {
      id: '/perfil/foto/preview'
      path: '/perfil/foto/preview'
      fullPath: '/perfil/foto/preview'
      preLoaderRoute: typeof PerfilFotoPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/perfil/editar/selecionar-formacao': {
      id: '/perfil/editar/selecionar-formacao'
      path: '/perfil/editar/selecionar-formacao'
      fullPath: '/perfil/editar/selecionar-formacao'
      preLoaderRoute: typeof PerfilEditarSelecionarFormacaoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/perfil/editar/email': {
      id: '/perfil/editar/email'
      path: '/perfil/editar/email'
      fullPath: '/perfil/editar/email'
      preLoaderRoute: typeof PerfilEditarEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/perfil/editar/adicionar-formacao': {
      id: '/perfil/editar/adicionar-formacao'
      path: '/perfil/editar/adicionar-formacao'
      fullPath: '/perfil/editar/adicionar-formacao'
      preLoaderRoute: typeof PerfilEditarAdicionarFormacaoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/perfil/editar/adicionar-curriculo': {
      id: '/perfil/editar/adicionar-curriculo'
      path: '/perfil/editar/adicionar-curriculo'
      fullPath: '/perfil/editar/adicionar-curriculo'
      preLoaderRoute: typeof PerfilEditarAdicionarCurriculoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/perfil/dados-pessoais/verificacao': {
      id: '/perfil/dados-pessoais/verificacao'
      path: '/verificacao'
      fullPath: '/perfil/dados-pessoais/verificacao'
      preLoaderRoute: typeof PerfilDadosPessoaisVerificacaoRouteImport
      parentRoute: typeof PerfilDadosPessoaisRoute
    }
    '/perfil/dados-pessoais/localidade': {
      id: '/perfil/dados-pessoais/localidade'
      path: '/localidade'
      fullPath: '/perfil/dados-pessoais/localidade'
      preLoaderRoute: typeof PerfilDadosPessoaisLocalidadeRouteImport
      parentRoute: typeof PerfilDadosPessoaisRoute
    }
    '/perfil/dados-pessoais/diversidade': {
      id: '/perfil/dados-pessoais/diversidade'
      path: '/diversidade'
      fullPath: '/perfil/dados-pessoais/diversidade'
      preLoaderRoute: typeof PerfilDadosPessoaisDiversidadeRouteImport
      parentRoute: typeof PerfilDadosPessoaisRoute
    }
    '/perfil/dados-pessoais/celular': {
      id: '/perfil/dados-pessoais/celular'
      path: '/celular'
      fullPath: '/perfil/dados-pessoais/celular'
      preLoaderRoute: typeof PerfilDadosPessoaisCelularRouteImport
      parentRoute: typeof PerfilDadosPessoaisRoute
    }
    '/perfil/curriculo_/sucesso': {
      id: '/perfil/curriculo_/sucesso'
      path: '/perfil/curriculo/sucesso'
      fullPath: '/perfil/curriculo/sucesso'
      preLoaderRoute: typeof PerfilCurriculoSucessoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/perfil/curriculo/revisar': {
      id: '/perfil/curriculo/revisar'
      path: '/revisar'
      fullPath: '/perfil/curriculo/revisar'
      preLoaderRoute: typeof PerfilCurriculoRevisarRouteImport
      parentRoute: typeof PerfilCurriculoRoute
    }
    '/perfil/curriculo/previa': {
      id: '/perfil/curriculo/previa'
      path: '/previa'
      fullPath: '/perfil/curriculo/previa'
      preLoaderRoute: typeof PerfilCurriculoPreviaRouteImport
      parentRoute: typeof PerfilCurriculoRoute
    }
    '/perfil/curriculo/enviar': {
      id: '/perfil/curriculo/enviar'
      path: '/enviar'
      fullPath: '/perfil/curriculo/enviar'
      preLoaderRoute: typeof PerfilCurriculoEnviarRouteImport
      parentRoute: typeof PerfilCurriculoRoute
    }
    '/perfil/curriculo/editar': {
      id: '/perfil/curriculo/editar'
      path: '/editar'
      fullPath: '/perfil/curriculo/editar'
      preLoaderRoute: typeof PerfilCurriculoEditarRouteImport
      parentRoute: typeof PerfilCurriculoRoute
    }
    '/perfil/curriculo/dados-pessoais': {
      id: '/perfil/curriculo/dados-pessoais'
      path: '/dados-pessoais'
      fullPath: '/perfil/curriculo/dados-pessoais'
      preLoaderRoute: typeof PerfilCurriculoDadosPessoaisRouteImport
      parentRoute: typeof PerfilCurriculoRoute
    }
    '/modulos/$moduleId_/curriculo': {
      id: '/modulos/$moduleId_/curriculo'
      path: '/modulos/$moduleId/curriculo'
      fullPath: '/modulos/$moduleId/curriculo'
      preLoaderRoute: typeof ModulosModuleIdCurriculoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vagas/$jobId_/inscricao/': {
      id: '/vagas/$jobId_/inscricao/'
      path: '/'
      fullPath: '/vagas/$jobId/inscricao/'
      preLoaderRoute: typeof VagasJobIdInscricaoIndexRouteImport
      parentRoute: typeof VagasJobIdInscricaoRoute
    }
    '/perfil/editar/formacoes/': {
      id: '/perfil/editar/formacoes/'
      path: '/perfil/editar/formacoes'
      fullPath: '/perfil/editar/formacoes/'
      preLoaderRoute: typeof PerfilEditarFormacoesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/perfil/curriculo/$section/': {
      id: '/perfil/curriculo/$section/'
      path: '/$section'
      fullPath: '/perfil/curriculo/$section/'
      preLoaderRoute: typeof PerfilCurriculoSectionIndexRouteImport
      parentRoute: typeof PerfilCurriculoRoute
    }
    '/modulos/$moduleId_/curriculo/': {
      id: '/modulos/$moduleId_/curriculo/'
      path: '/'
      fullPath: '/modulos/$moduleId/curriculo/'
      preLoaderRoute: typeof ModulosModuleIdCurriculoIndexRouteImport
      parentRoute: typeof ModulosModuleIdCurriculoRoute
    }
    '/vagas/$jobId_/inscricao/revisao': {
      id: '/vagas/$jobId_/inscricao/revisao'
      path: '/revisao'
      fullPath: '/vagas/$jobId/inscricao/revisao'
      preLoaderRoute: typeof VagasJobIdInscricaoRevisaoRouteImport
      parentRoute: typeof VagasJobIdInscricaoRoute
    }
    '/vagas/$jobId_/inscricao/programa-em-andamento': {
      id: '/vagas/$jobId_/inscricao/programa-em-andamento'
      path: '/programa-em-andamento'
      fullPath: '/vagas/$jobId/inscricao/programa-em-andamento'
      preLoaderRoute: typeof VagasJobIdInscricaoProgramaEmAndamentoRouteImport
      parentRoute: typeof VagasJobIdInscricaoRoute
    }
    '/vagas/$jobId_/inscricao/formulario': {
      id: '/vagas/$jobId_/inscricao/formulario'
      path: '/formulario'
      fullPath: '/vagas/$jobId/inscricao/formulario'
      preLoaderRoute: typeof VagasJobIdInscricaoFormularioRouteImport
      parentRoute: typeof VagasJobIdInscricaoRoute
    }
    '/vagas/$jobId_/inscricao/areas-de-atuacao': {
      id: '/vagas/$jobId_/inscricao/areas-de-atuacao'
      path: '/areas-de-atuacao'
      fullPath: '/vagas/$jobId/inscricao/areas-de-atuacao'
      preLoaderRoute: typeof VagasJobIdInscricaoAreasDeAtuacaoRouteImport
      parentRoute: typeof VagasJobIdInscricaoRoute
    }
    '/vagas/$jobId_/inscricao/acessibilidade': {
      id: '/vagas/$jobId_/inscricao/acessibilidade'
      path: '/acessibilidade'
      fullPath: '/vagas/$jobId/inscricao/acessibilidade'
      preLoaderRoute: typeof VagasJobIdInscricaoAcessibilidadeRouteImport
      parentRoute: typeof VagasJobIdInscricaoRoute
    }
    '/users/$userId/subscription/order-priority': {
      id: '/users/$userId/subscription/order-priority'
      path: '/users/$userId/subscription/order-priority'
      fullPath: '/users/$userId/subscription/order-priority'
      preLoaderRoute: typeof UsersUserIdSubscriptionOrderPriorityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$userId/subscription/$subscriptionId': {
      id: '/users/$userId/subscription/$subscriptionId'
      path: '/users/$userId/subscription/$subscriptionId'
      fullPath: '/users/$userId/subscription/$subscriptionId'
      preLoaderRoute: typeof UsersUserIdSubscriptionSubscriptionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/perfil/editar/formacoes/$id': {
      id: '/perfil/editar/formacoes/$id'
      path: '/perfil/editar/formacoes/$id'
      fullPath: '/perfil/editar/formacoes/$id'
      preLoaderRoute: typeof PerfilEditarFormacoesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/perfil/curriculo/$section/nova': {
      id: '/perfil/curriculo/$section/nova'
      path: '/$section/nova'
      fullPath: '/perfil/curriculo/$section/nova'
      preLoaderRoute: typeof PerfilCurriculoSectionNovaRouteImport
      parentRoute: typeof PerfilCurriculoRoute
    }
    '/modulos/$moduleId_/curriculo/revisar': {
      id: '/modulos/$moduleId_/curriculo/revisar'
      path: '/revisar'
      fullPath: '/modulos/$moduleId/curriculo/revisar'
      preLoaderRoute: typeof ModulosModuleIdCurriculoRevisarRouteImport
      parentRoute: typeof ModulosModuleIdCurriculoRoute
    }
    '/modulos/$moduleId_/curriculo/previa': {
      id: '/modulos/$moduleId_/curriculo/previa'
      path: '/previa'
      fullPath: '/modulos/$moduleId/curriculo/previa'
      preLoaderRoute: typeof ModulosModuleIdCurriculoPreviaRouteImport
      parentRoute: typeof ModulosModuleIdCurriculoRoute
    }
    '/modulos/$moduleId_/curriculo/enviar': {
      id: '/modulos/$moduleId_/curriculo/enviar'
      path: '/enviar'
      fullPath: '/modulos/$moduleId/curriculo/enviar'
      preLoaderRoute: typeof ModulosModuleIdCurriculoEnviarRouteImport
      parentRoute: typeof ModulosModuleIdCurriculoRoute
    }
    '/modulos/$moduleId_/curriculo/editar': {
      id: '/modulos/$moduleId_/curriculo/editar'
      path: '/editar'
      fullPath: '/modulos/$moduleId/curriculo/editar'
      preLoaderRoute: typeof ModulosModuleIdCurriculoEditarRouteImport
      parentRoute: typeof ModulosModuleIdCurriculoRoute
    }
    '/modulos/$moduleId_/curriculo/dados-pessoais': {
      id: '/modulos/$moduleId_/curriculo/dados-pessoais'
      path: '/dados-pessoais'
      fullPath: '/modulos/$moduleId/curriculo/dados-pessoais'
      preLoaderRoute: typeof ModulosModuleIdCurriculoDadosPessoaisRouteImport
      parentRoute: typeof ModulosModuleIdCurriculoRoute
    }
    '/modulos/$moduleId_/curriculo/$section/': {
      id: '/modulos/$moduleId_/curriculo/$section/'
      path: '/$section'
      fullPath: '/modulos/$moduleId/curriculo/$section/'
      preLoaderRoute: typeof ModulosModuleIdCurriculoSectionIndexRouteImport
      parentRoute: typeof ModulosModuleIdCurriculoRoute
    }
    '/perfil/curriculo/$section/$itemId/editar': {
      id: '/perfil/curriculo/$section/$itemId/editar'
      path: '/$section/$itemId/editar'
      fullPath: '/perfil/curriculo/$section/$itemId/editar'
      preLoaderRoute: typeof PerfilCurriculoSectionItemIdEditarRouteImport
      parentRoute: typeof PerfilCurriculoRoute
    }
    '/modulos/$moduleId_/curriculo/$section/nova': {
      id: '/modulos/$moduleId_/curriculo/$section/nova'
      path: '/$section/nova'
      fullPath: '/modulos/$moduleId/curriculo/$section/nova'
      preLoaderRoute: typeof ModulosModuleIdCurriculoSectionNovaRouteImport
      parentRoute: typeof ModulosModuleIdCurriculoRoute
    }
    '/modulos/$moduleId_/curriculo/$section/$itemId/editar': {
      id: '/modulos/$moduleId_/curriculo/$section/$itemId/editar'
      path: '/$section/$itemId/editar'
      fullPath: '/modulos/$moduleId/curriculo/$section/$itemId/editar'
      preLoaderRoute: typeof ModulosModuleIdCurriculoSectionItemIdEditarRouteImport
      parentRoute: typeof ModulosModuleIdCurriculoRoute
    }
  }
}

interface OnboardingRouteChildren {
  OnboardingCelularRoute: typeof OnboardingCelularRoute
  OnboardingFormacaoRoute: typeof OnboardingFormacaoRoute
  OnboardingLocalidadeRoute: typeof OnboardingLocalidadeRoute
  OnboardingTermosRoute: typeof OnboardingTermosRoute
  OnboardingVerificacaoRoute: typeof OnboardingVerificacaoRoute
  OnboardingIndexRoute: typeof OnboardingIndexRoute
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingCelularRoute: OnboardingCelularRoute,
  OnboardingFormacaoRoute: OnboardingFormacaoRoute,
  OnboardingLocalidadeRoute: OnboardingLocalidadeRoute,
  OnboardingTermosRoute: OnboardingTermosRoute,
  OnboardingVerificacaoRoute: OnboardingVerificacaoRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

interface PerfilCurriculoRouteChildren {
  PerfilCurriculoDadosPessoaisRoute: typeof PerfilCurriculoDadosPessoaisRoute
  PerfilCurriculoEditarRoute: typeof PerfilCurriculoEditarRoute
  PerfilCurriculoEnviarRoute: typeof PerfilCurriculoEnviarRoute
  PerfilCurriculoPreviaRoute: typeof PerfilCurriculoPreviaRoute
  PerfilCurriculoRevisarRoute: typeof PerfilCurriculoRevisarRoute
  PerfilCurriculoIndexRoute: typeof PerfilCurriculoIndexRoute
  PerfilCurriculoSectionNovaRoute: typeof PerfilCurriculoSectionNovaRoute
  PerfilCurriculoSectionIndexRoute: typeof PerfilCurriculoSectionIndexRoute
  PerfilCurriculoSectionItemIdEditarRoute: typeof PerfilCurriculoSectionItemIdEditarRoute
}

const PerfilCurriculoRouteChildren: PerfilCurriculoRouteChildren = {
  PerfilCurriculoDadosPessoaisRoute: PerfilCurriculoDadosPessoaisRoute,
  PerfilCurriculoEditarRoute: PerfilCurriculoEditarRoute,
  PerfilCurriculoEnviarRoute: PerfilCurriculoEnviarRoute,
  PerfilCurriculoPreviaRoute: PerfilCurriculoPreviaRoute,
  PerfilCurriculoRevisarRoute: PerfilCurriculoRevisarRoute,
  PerfilCurriculoIndexRoute: PerfilCurriculoIndexRoute,
  PerfilCurriculoSectionNovaRoute: PerfilCurriculoSectionNovaRoute,
  PerfilCurriculoSectionIndexRoute: PerfilCurriculoSectionIndexRoute,
  PerfilCurriculoSectionItemIdEditarRoute:
    PerfilCurriculoSectionItemIdEditarRoute,
}

const PerfilCurriculoRouteWithChildren = PerfilCurriculoRoute._addFileChildren(
  PerfilCurriculoRouteChildren,
)

interface PerfilDadosPessoaisRouteChildren {
  PerfilDadosPessoaisCelularRoute: typeof PerfilDadosPessoaisCelularRoute
  PerfilDadosPessoaisDiversidadeRoute: typeof PerfilDadosPessoaisDiversidadeRoute
  PerfilDadosPessoaisLocalidadeRoute: typeof PerfilDadosPessoaisLocalidadeRoute
  PerfilDadosPessoaisVerificacaoRoute: typeof PerfilDadosPessoaisVerificacaoRoute
  PerfilDadosPessoaisIndexRoute: typeof PerfilDadosPessoaisIndexRoute
}

const PerfilDadosPessoaisRouteChildren: PerfilDadosPessoaisRouteChildren = {
  PerfilDadosPessoaisCelularRoute: PerfilDadosPessoaisCelularRoute,
  PerfilDadosPessoaisDiversidadeRoute: PerfilDadosPessoaisDiversidadeRoute,
  PerfilDadosPessoaisLocalidadeRoute: PerfilDadosPessoaisLocalidadeRoute,
  PerfilDadosPessoaisVerificacaoRoute: PerfilDadosPessoaisVerificacaoRoute,
  PerfilDadosPessoaisIndexRoute: PerfilDadosPessoaisIndexRoute,
}

const PerfilDadosPessoaisRouteWithChildren =
  PerfilDadosPessoaisRoute._addFileChildren(PerfilDadosPessoaisRouteChildren)

interface ModulosModuleIdCurriculoRouteChildren {
  ModulosModuleIdCurriculoDadosPessoaisRoute: typeof ModulosModuleIdCurriculoDadosPessoaisRoute
  ModulosModuleIdCurriculoEditarRoute: typeof ModulosModuleIdCurriculoEditarRoute
  ModulosModuleIdCurriculoEnviarRoute: typeof ModulosModuleIdCurriculoEnviarRoute
  ModulosModuleIdCurriculoPreviaRoute: typeof ModulosModuleIdCurriculoPreviaRoute
  ModulosModuleIdCurriculoRevisarRoute: typeof ModulosModuleIdCurriculoRevisarRoute
  ModulosModuleIdCurriculoIndexRoute: typeof ModulosModuleIdCurriculoIndexRoute
  ModulosModuleIdCurriculoSectionNovaRoute: typeof ModulosModuleIdCurriculoSectionNovaRoute
  ModulosModuleIdCurriculoSectionIndexRoute: typeof ModulosModuleIdCurriculoSectionIndexRoute
  ModulosModuleIdCurriculoSectionItemIdEditarRoute: typeof ModulosModuleIdCurriculoSectionItemIdEditarRoute
}

const ModulosModuleIdCurriculoRouteChildren: ModulosModuleIdCurriculoRouteChildren =
  {
    ModulosModuleIdCurriculoDadosPessoaisRoute:
      ModulosModuleIdCurriculoDadosPessoaisRoute,
    ModulosModuleIdCurriculoEditarRoute: ModulosModuleIdCurriculoEditarRoute,
    ModulosModuleIdCurriculoEnviarRoute: ModulosModuleIdCurriculoEnviarRoute,
    ModulosModuleIdCurriculoPreviaRoute: ModulosModuleIdCurriculoPreviaRoute,
    ModulosModuleIdCurriculoRevisarRoute: ModulosModuleIdCurriculoRevisarRoute,
    ModulosModuleIdCurriculoIndexRoute: ModulosModuleIdCurriculoIndexRoute,
    ModulosModuleIdCurriculoSectionNovaRoute:
      ModulosModuleIdCurriculoSectionNovaRoute,
    ModulosModuleIdCurriculoSectionIndexRoute:
      ModulosModuleIdCurriculoSectionIndexRoute,
    ModulosModuleIdCurriculoSectionItemIdEditarRoute:
      ModulosModuleIdCurriculoSectionItemIdEditarRoute,
  }

const ModulosModuleIdCurriculoRouteWithChildren =
  ModulosModuleIdCurriculoRoute._addFileChildren(
    ModulosModuleIdCurriculoRouteChildren,
  )

interface VagasJobIdInscricaoRouteChildren {
  VagasJobIdInscricaoAcessibilidadeRoute: typeof VagasJobIdInscricaoAcessibilidadeRoute
  VagasJobIdInscricaoAreasDeAtuacaoRoute: typeof VagasJobIdInscricaoAreasDeAtuacaoRoute
  VagasJobIdInscricaoFormularioRoute: typeof VagasJobIdInscricaoFormularioRoute
  VagasJobIdInscricaoProgramaEmAndamentoRoute: typeof VagasJobIdInscricaoProgramaEmAndamentoRoute
  VagasJobIdInscricaoRevisaoRoute: typeof VagasJobIdInscricaoRevisaoRoute
  VagasJobIdInscricaoIndexRoute: typeof VagasJobIdInscricaoIndexRoute
}

const VagasJobIdInscricaoRouteChildren: VagasJobIdInscricaoRouteChildren = {
  VagasJobIdInscricaoAcessibilidadeRoute:
    VagasJobIdInscricaoAcessibilidadeRoute,
  VagasJobIdInscricaoAreasDeAtuacaoRoute:
    VagasJobIdInscricaoAreasDeAtuacaoRoute,
  VagasJobIdInscricaoFormularioRoute: VagasJobIdInscricaoFormularioRoute,
  VagasJobIdInscricaoProgramaEmAndamentoRoute:
    VagasJobIdInscricaoProgramaEmAndamentoRoute,
  VagasJobIdInscricaoRevisaoRoute: VagasJobIdInscricaoRevisaoRoute,
  VagasJobIdInscricaoIndexRoute: VagasJobIdInscricaoIndexRoute,
}

const VagasJobIdInscricaoRouteWithChildren =
  VagasJobIdInscricaoRoute._addFileChildren(VagasJobIdInscricaoRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BoasVindasRoute: BoasVindasRoute,
  ContaExcluidaRoute: ContaExcluidaRoute,
  EscolherEmailRoute: EscolherEmailRoute,
  OnboardingRoute: OnboardingRouteWithChildren,
  PoliticaDePrivacidadeRoute: PoliticaDePrivacidadeRoute,
  TermosDeUsoRoute: TermosDeUsoRoute,
  ModulosModuleIdRoute: ModulosModuleIdRoute,
  ModulosConclusaoRoute: ModulosConclusaoRoute,
  PerfilContasVinculadasRoute: PerfilContasVinculadasRoute,
  PerfilCurriculoRoute: PerfilCurriculoRouteWithChildren,
  PerfilDadosPessoaisRoute: PerfilDadosPessoaisRouteWithChildren,
  PerfilTrocarSenhaRoute: PerfilTrocarSenhaRoute,
  ProgramasIdRoute: ProgramasIdRoute,
  SubscriptionSuccessRoute: SubscriptionSuccessRoute,
  VagasJobIdRoute: VagasJobIdRoute,
  VagasMotivoReprovacaoEmailRoute: VagasMotivoReprovacaoEmailRoute,
  ModulosIndexRoute: ModulosIndexRoute,
  OportunidadesIndexRoute: OportunidadesIndexRoute,
  PerfilIndexRoute: PerfilIndexRoute,
  ProgramasIndexRoute: ProgramasIndexRoute,
  VagasIndexRoute: VagasIndexRoute,
  ModulosModuleIdCurriculoRoute: ModulosModuleIdCurriculoRouteWithChildren,
  PerfilCurriculoSucessoRoute: PerfilCurriculoSucessoRoute,
  PerfilEditarAdicionarCurriculoRoute: PerfilEditarAdicionarCurriculoRoute,
  PerfilEditarAdicionarFormacaoRoute: PerfilEditarAdicionarFormacaoRoute,
  PerfilEditarEmailRoute: PerfilEditarEmailRoute,
  PerfilEditarSelecionarFormacaoRoute: PerfilEditarSelecionarFormacaoRoute,
  PerfilFotoPreviewRoute: PerfilFotoPreviewRoute,
  VagasJobIdInscricaoRoute: VagasJobIdInscricaoRouteWithChildren,
  VagasJobIdProcessoRoute: VagasJobIdProcessoRoute,
  PerfilExcluirContaIndexRoute: PerfilExcluirContaIndexRoute,
  PerfilFotoIndexRoute: PerfilFotoIndexRoute,
  VagasMotivoReprovacaoIndexRoute: VagasMotivoReprovacaoIndexRoute,
  PerfilEditarFormacoesIdRoute: PerfilEditarFormacoesIdRoute,
  UsersUserIdSubscriptionSubscriptionIdRoute:
    UsersUserIdSubscriptionSubscriptionIdRoute,
  UsersUserIdSubscriptionOrderPriorityRoute:
    UsersUserIdSubscriptionOrderPriorityRoute,
  PerfilEditarFormacoesIndexRoute: PerfilEditarFormacoesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
